import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/timer")({
  component: TimerLayout,
});

function TimerLayout() {
  return <Outlet />;
}
